import { render } from "./AboutPageHeder.vue?vue&type=template&id=5435d3f2&scoped=true"
import script from "./AboutPageHeder.vue?vue&type=script&lang=js"
export * from "./AboutPageHeder.vue?vue&type=script&lang=js"

import "./AboutPageHeder.vue?vue&type=style&index=0&id=5435d3f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5435d3f2"]])

export default __exports__